export default {
    ACOMPANHANTE: 0,
    PACIENTE: 1,
}